import essLocalApi from "../axios/esspLocalApi";

class SampleService {

    async getUsers() {
        return Promise.resolve(essLocalApi.get(`users.json`));
    }

    async getTreeData() {
        return Promise.resolve(essLocalApi.get(`tree.json`));
    }


}
export default SampleService;